var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"btn btn-link",attrs:{"type":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[_c('Icon',{staticClass:"icon-grow mr-2"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }